import { useTimeOffsApi } from '@api/tutor-kanban/time-offs.hook'

import { defineNuxtRouteMiddleware } from '#app'

export default defineNuxtRouteMiddleware((to) => {
  const tutorId = to.params.id as string

  void useTimeOffsApi({ tutorId })
})
